import type { Step } from 'react-joyride';

export const policyCreateTourSteps: Step[] = [
    {
        target: 'body',
        content:
            'ໜ້ານີ້ແມ່ນສຳລັບສ້າງນະໂຍບາຍໃໝ່. ທ່ານສາມາດປ້ອນຂໍ້ມູນພື້ນຖານ ແລະ ເນື້ອໃນນະໂຍບາຍໄດ້ທີ່ນີ້.',
        placement: 'center',
        disableBeacon: true,
    },
    {
        target: '[data-tourid="policy-create-back"]',
        content: 'ສ່ວນຫົວໜ້າຂອງໜ້າ: ມີປຸ່ມກັບໄປລາຍການ ແລະ ປຸ່ມເລີ່ມທົດສອບ.',
        placement: 'bottom',
    },
    {
        target: '[data-tourid="policy-create-form"]',
        content:
            'ຟອມສ້າງນະໂຍບາຍ: ປ້ອນຫົວຂໍ້, ປະເພດ, ວັນທີມີຜົນ, ແລະ ເນື້ອໃນ ກ່ອນບັນທຶກ.',
        placement: 'top',
    },
];
